// eslint-disable-next-line import/no-anonymous-default-export
export default (token) => {
  if (!token) return false;

  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");

  return JSON.parse(window.atob(base64));
};
